import { render, staticRenderFns } from "./BeefBasicSettingsModal.vue?vue&type=template&id=41d92d66"
import script from "./BeefBasicSettingsModal.vue?vue&type=script&lang=js"
export * from "./BeefBasicSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports